import React from "react";
import { ArrowUpRight, CheckCircle2 } from "lucide-react";
import { useT } from "@/lib/i18n";

/**
 * FLOW promo block — links to the existing flow.wedocoaching.com program.
 */
export default function FlowProgramCard() {
  const t = useT();
  const bullets = t("flowProgram.bullets", []) || [];
  const modules = t("flowProgram.modules", []) || [];
  return (
    <section data-testid="flow-program-card" className="bg-brand-deep text-white py-24 md:py-32 relative overflow-hidden">
      <div className="absolute inset-0 opacity-25">
        <img src="/brand/gradient_wedo.jpg" alt="" className="w-full h-full object-cover mix-blend-overlay" />
      </div>
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 lg:px-16 relative">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 items-center">
          <div className="md:col-span-7">
            <p className="section-num text-accent-pink">{t("flowProgram.eyebrow")}</p>
            <h2 className="display text-4xl md:text-6xl lg:text-7xl leading-[1.02] mt-6">
              {t("flowProgram.titleA")}<span className="text-accent-yellow">{t("flowProgram.titleAccent")}</span>
            </h2>
            <p className="text-white/85 text-base md:text-lg leading-relaxed mt-8 max-w-2xl">
              {t("flowProgram.lede")}
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mt-10 max-w-2xl">
              {bullets.map((b) => (
                <div key={b} className="flex items-start gap-3 border-t border-white/15 pt-3">
                  <CheckCircle2 size={16} className="text-accent-lime shrink-0 mt-0.5" />
                  <p className="text-[14px] leading-relaxed text-white/85">{b}</p>
                </div>
              ))}
            </div>
            <div className="mt-12 flex flex-wrap gap-4">
              <a
                href="https://flow.wedocoaching.com"
                target="_blank"
                rel="noreferrer"
                data-testid="flow-program-cta"
                className="btn-pill bg-accent-pink text-white hover:bg-white hover:text-brand"
              >
                {t("flowProgram.cta")} <ArrowUpRight size={16} />
              </a>
              <p className="text-white/85 text-sm italic self-center display">flow.wedocoaching.com</p>
            </div>
          </div>

          <div className="md:col-span-5">
            <div className="relative">
              <div className="absolute -inset-2 bg-gradient-to-br from-accent-pink via-accent-orange to-accent-yellow opacity-50 blur-3xl rounded-3xl" />
              <div className="relative bg-paper text-ink rounded-2xl shadow-2xl overflow-hidden">
                <div className="p-8 md:p-10 space-y-5">
                  <div className="flex items-center gap-3">
                    <div className="display italic text-2xl text-brand">FLOW</div>
                    <span className="text-[10px] uppercase tracking-[0.3em] text-ink/50">by Wedo</span>
                  </div>
                  <h3 className="display text-2xl md:text-3xl leading-tight text-brand-deep">
                    {t("flowProgram.baseline")}
                  </h3>
                  <div className="border-t border-ink/10 pt-5 space-y-3">
                    {modules.map((m) => (
                      <div key={m.n} className="flex items-center gap-4 group">
                        <span className="display italic text-sm text-accent-pink w-8">{m.n}</span>
                        <p className="text-[14px] text-ink/85 group-hover:text-brand transition-colors">{m.t}</p>
                        <span className="ml-auto text-[11px] text-ink/40">~15j</span>
                      </div>
                    ))}
                  </div>
                  <div className="border-t border-ink/10 pt-4 flex items-center justify-between">
                    <p className="text-[11px] uppercase tracking-[0.25em] text-ink/50">{t("flowProgram.footer")}</p>
                    <span className="w-2 h-2 rounded-full bg-accent-lime animate-pulse" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
